<template>
    <div class="container-fluid">
        <div class="row">

            <div class="col">
                <card>
                    <h4 class="text-muted">Actions</h4>
                    <div class="btn-group ">
                        <base-button type="default" @click="showCreateModal = true" class="mb-3">Add Timecondition
                        </base-button>
                    </div>
                </card>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6" v-for="timecondition in timeconditions">
                <timecondition-card
                        :key="timecondition.id"

                        :initial-timecondition="JSON.parse(JSON.stringify(timecondition))"
                        v-on:removed="loadTimeconditions"></timecondition-card>
            </div>


        </div>

        <new-timecondition-modal :show.sync="showCreateModal"
                                 v-on:created="loadTimeconditions"></new-timecondition-modal>
    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import TimeconditionCard from "./TimeconditionCard";
    import NewTimeconditionModal from "./NewTimeconditionModal";

    export default {
        name: "Timeconditions",
        components: {
            NewTimeconditionModal,
            TimeconditionCard,
        },
        computed: {
            ...mapFields(`timecondition`, ['timeconditions']),
        },
        data() {
            return {
                isLoading: false,
                showCreateModal: false,
            };
        },
        methods: {
            updateShow(value) {
                this.showCreateModal = value;
            },
            reset() {
                this.loadTimeconditions();
            },
            loadTimeconditions() {
                this.isLoading = true;
                this.$store.dispatch('timecondition/load').then(() => {
                    this.isLoading = false;
                })
            },
        },
        mounted() {
            this.loadTimeconditions();
        },
    }
</script>

<style scoped>

</style>